/* tslint:disable */
/* eslint-disable */
/**
 * BuLLy documentation
 * BuLLy Server
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redcare-pharmacy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setBearerAuthToObject, setSearchParams, toPathString, createRequestFunction } from '../common.js';
// @ts-ignore
import { BASE_PATH, BaseAPI, operationServerMap } from '../base.js';
/**
 * ReavailabilityNotificationControllerApi - axios parameter creator
 */
export const ReavailabilityNotificationControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get information whether customer has subscribed to passed product
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} upid Unique product identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reavailabilityV1TenantCustomerSubscriptionStatusUpidGet: (tenant_1, upid_1, ...args_1) => __awaiter(this, [tenant_1, upid_1, ...args_1], void 0, function* (tenant, upid, options = {}) {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('reavailabilityV1TenantCustomerSubscriptionStatusUpidGet', 'tenant', tenant);
            // verify required parameter 'upid' is not null or undefined
            assertParamExists('reavailabilityV1TenantCustomerSubscriptionStatusUpidGet', 'upid', upid);
            const localVarPath = `/reavailability/v1/{tenant}/customer-subscription-status/{upid}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"upid"}}`, encodeURIComponent(String(upid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Subscribing to reavailability notification for a product
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} upid Unique product identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reavailabilityV1TenantSubscribeUpidPost: (tenant_1, upid_1, ...args_1) => __awaiter(this, [tenant_1, upid_1, ...args_1], void 0, function* (tenant, upid, options = {}) {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('reavailabilityV1TenantSubscribeUpidPost', 'tenant', tenant);
            // verify required parameter 'upid' is not null or undefined
            assertParamExists('reavailabilityV1TenantSubscribeUpidPost', 'upid', upid);
            const localVarPath = `/reavailability/v1/{tenant}/subscribe/{upid}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"upid"}}`, encodeURIComponent(String(upid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ReavailabilityNotificationControllerApi - functional programming interface
 */
export const ReavailabilityNotificationControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = ReavailabilityNotificationControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get information whether customer has subscribed to passed product
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} upid Unique product identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reavailabilityV1TenantCustomerSubscriptionStatusUpidGet(tenant, upid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reavailabilityV1TenantCustomerSubscriptionStatusUpidGet(tenant, upid, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ReavailabilityNotificationControllerApi.reavailabilityV1TenantCustomerSubscriptionStatusUpidGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Subscribing to reavailability notification for a product
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} upid Unique product identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reavailabilityV1TenantSubscribeUpidPost(tenant, upid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reavailabilityV1TenantSubscribeUpidPost(tenant, upid, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ReavailabilityNotificationControllerApi.reavailabilityV1TenantSubscribeUpidPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * ReavailabilityNotificationControllerApi - factory interface
 */
export const ReavailabilityNotificationControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ReavailabilityNotificationControllerApiFp(configuration);
    return {
        /**
         *
         * @summary Get information whether customer has subscribed to passed product
         * @param {ReavailabilityNotificationControllerApiReavailabilityV1TenantCustomerSubscriptionStatusUpidGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reavailabilityV1TenantCustomerSubscriptionStatusUpidGet(requestParameters, options) {
            return localVarFp.reavailabilityV1TenantCustomerSubscriptionStatusUpidGet(requestParameters.tenant, requestParameters.upid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Subscribing to reavailability notification for a product
         * @param {ReavailabilityNotificationControllerApiReavailabilityV1TenantSubscribeUpidPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reavailabilityV1TenantSubscribeUpidPost(requestParameters, options) {
            return localVarFp.reavailabilityV1TenantSubscribeUpidPost(requestParameters.tenant, requestParameters.upid, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ReavailabilityNotificationControllerApi - object-oriented interface
 */
export class ReavailabilityNotificationControllerApi extends BaseAPI {
    /**
     *
     * @summary Get information whether customer has subscribed to passed product
     * @param {ReavailabilityNotificationControllerApiReavailabilityV1TenantCustomerSubscriptionStatusUpidGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reavailabilityV1TenantCustomerSubscriptionStatusUpidGet(requestParameters, options) {
        return ReavailabilityNotificationControllerApiFp(this.configuration).reavailabilityV1TenantCustomerSubscriptionStatusUpidGet(requestParameters.tenant, requestParameters.upid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Subscribing to reavailability notification for a product
     * @param {ReavailabilityNotificationControllerApiReavailabilityV1TenantSubscribeUpidPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reavailabilityV1TenantSubscribeUpidPost(requestParameters, options) {
        return ReavailabilityNotificationControllerApiFp(this.configuration).reavailabilityV1TenantSubscribeUpidPost(requestParameters.tenant, requestParameters.upid, options).then((request) => request(this.axios, this.basePath));
    }
}
